import type { ImageArray } from "@pdfking/compatibility"
import type { Percentage, Pixel } from "@pdfking/renderer-api"

export const ImageDiff = (
  a: ImageArray,
  b: ImageArray,
  amplify: Percentage = 10 as Percentage
): ImageArray => {
  if (a.width !== b.width || a.height !== b.height) {
    throw new Error(
      `ImageDiff: size mismatch ${a.width}x${a.height} vs ${b.width}x${b.height}`
    )
  }

  const data = new Uint8Array(a.data.length)

  for (let i = 0; i < a.data.length; i += 4) {
    const avgDiff =
      (Math.abs(a.data[i] - b.data[i]) +
        Math.abs(a.data[i + 1] - b.data[i + 1]) +
        Math.abs(a.data[i + 2] - b.data[i + 2]) +
        Math.abs(a.data[i + 3] - b.data[i + 3])) /
      4
    const gray = 255 - Math.min(255, avgDiff * amplify)
    data[i] = gray
    data[i + 1] = gray
    data[i + 2] = gray
    data[i + 3] = 255
  }

  return { width: a.width as Pixel, height: a.height as Pixel, data }
}
